import React from 'react'
import Lots from './Common/Lots'

const WinningLots = () => <Lots apiEndpoint='/api/lots/winning' />

export default WinningLots
